import { ApplicationEmailSettings, UserSettings, BodyEmailTemplate } from '@numeo/types-core'
import axios from 'axios'

export const saveEmailSettings = async (emailSettings: ApplicationEmailSettings & { userSettings: UserSettings }) => {
    try {
        const response = await axios.post('/email/email-settings', emailSettings)
        return response
    } catch (error) {
        console.error('Error saving email settings:', error)
        throw error
    }
}

export const getEmailSettings = async () => {
    try {
        // Perform GET request to fetch email settings
        const response = await axios.get('/email/email-settings')

        // Return the response data
        return response.data
    } catch (error) {
        console.error('Error fetching email settings:', error)
        throw error // Optionally, throw the error if you want to handle it in the calling function
    }
}

// Save email footer settings to the server
export const saveFooterSettings = async (footer: string) => {
    try {
        const response = await axios.post('/email/footer-settings', { footer })
        return response
    } catch (error) {
        console.error('Error saving footer settings:', error)
        throw error
    }
}

// Save email template
export const saveEmailTemplate = async (template: BodyEmailTemplate & { emailFooter?: string }) => {
    try {
        const response = await axios.post('/email/template-settings', template)
        return response
    } catch (error) {
        console.error('Error saving email template:', error)
        throw error
    }
}
